var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 13.5823 2.46919 15.129 3.34824 16.4446C4.22729 17.7602 5.47672 18.7855 6.93853 19.391C8.40034 19.9965 10.0089 20.155 11.5607 19.8463C13.1126 19.5376 14.538 18.7757 15.6569 17.6569C16.7757 16.538 17.5376 15.1126 17.8463 13.5607C18.155 12.0089 17.9965 10.4003 17.391 8.93853C16.7855 7.47672 15.7602 6.22729 14.4446 5.34824C13.129 4.46919 11.5823 4 10 4C7.87827 4 5.84344 4.84285 4.34315 6.34315C2.84285 7.84344 2 9.87827 2 12ZM10 6C11.1867 6 12.3467 6.35189 13.3334 7.01118C14.3201 7.67047 15.0892 8.60754 15.5433 9.7039C15.9974 10.8003 16.1162 12.0067 15.8847 13.1705C15.6532 14.3344 15.0818 15.4035 14.2426 16.2426C13.4035 17.0818 12.3344 17.6532 11.1705 17.8847C10.0067 18.1162 8.80026 17.9974 7.7039 17.5433C6.60754 17.0892 5.67047 16.3201 5.01118 15.3334C4.35189 14.3467 4 13.1867 4 12C4 10.4087 4.63214 8.88258 5.75736 7.75736C6.88258 6.63214 8.4087 6 10 6Z",
    fill: "#d9d9d9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H8V2H12V0Z",
    fill: "#d9d9d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79012 1.79093L0.791992 4.78906L2.20621 6.20328L5.20434 3.20514L3.79012 1.79093Z",
    fill: "#d9d9d9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H9V13H11V8Z",
    fill: "#d9d9d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerGray);
export default __webpack_public_path__ + "static/media/timerGray.1047df2174d4a2eb526eacec94000869.svg";
export { ForwardRef as ReactComponent };